module.exports = __webpack_public_path__ + "bd22fd281ac2e4293d92b1e4041aea9a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./images/bigpic.jpg
 ** module id = 89
 ** module chunks = 0
 **/